/**
 * Centralized DnD item type constants.
 *
 * There are two logically distinct drag operations in the form builder:
 *
 *  - PALETTE_ELEMENT: The user drags a NEW component from the left-panel
 *    palette.  The drag source is `DragableItem`.  Valid drop targets are
 *    `AddChildItem` (canvas) and `ChildDropper` (layer panel).
 *
 *  - CANVAS_ELEMENT: The user drags an EXISTING component to reorder it.
 *    The drag source is `ComponentItem` (layer panel).  Valid drop targets
 *    are other `ComponentItem` containers and `ChildDropper` separators.
 *
 * Keeping these types separate prevents a palette drag from accidentally
 * triggering a reorder, and vice-versa.
 */
export const ItemTypes = {
  /** A brand-new element being dragged from the component palette */
  PALETTE_ELEMENT: 'palette_element',
  /** An existing canvas element being reordered via the layer panel */
  CANVAS_ELEMENT: 'canvas_element',
} as const

export type ItemType = (typeof ItemTypes)[keyof typeof ItemTypes]

/** Accept array: drop zones that need to handle both drag types */
export const ALL_ITEM_TYPES: ItemType[] = [ItemTypes.PALETTE_ELEMENT, ItemTypes.CANVAS_ELEMENT]
